import React from "react";

export type ResultOpponentStatus =
	| { status: "racing" }
	| { status: "finished"; place: number; timeMs: number }
	| { status: "dnf" };

export type ResultInfo = {
	place: number | null;
	dnf: boolean;
	timeMs: number | null;
	opponent: ResultOpponentStatus | null;
	timeGapMs: number | null;
};

function formatSeconds(ms: number): string {
	return `${(ms / 1000).toFixed(2)}s`;
}

export function ResultScreen({
	result,
	levelName,
	onPlayAgain,
	onViewLeaderboard,
	onNextLevel,
}: {
	result: ResultInfo;
	levelName?: string;
	onPlayAgain: () => void;
	onViewLeaderboard: () => void;
	onNextLevel?: () => void;
}) {
	return (
		<div className="App menu-screen">
			<h1>RK Beach Rampage</h1>
			<div className="pixel-panel pixel-frame result-panel">
				{levelName && <p className="result-level-name">{levelName}</p>}
				<h2 className={result.dnf ? "result-headline result-headline--dnf" : "result-headline"}>
					{result.dnf ? "Did Not Finish" : `Placement: ${result.place}`}
				</h2>
				{result.timeMs !== null && (
					<p className="result-row">
						<span className="result-row-label">Time</span>
						{formatSeconds(result.timeMs)}
					</p>
				)}
				{result.opponent && (
					<p className="result-row">
						<span className="result-row-label">Opponent</span>
						{result.opponent.status === "racing"
							? "Still racing"
							: result.opponent.status === "dnf"
								? "Did not finish"
								: `Placement ${result.opponent.place} (${formatSeconds(result.opponent.timeMs)})`}
					</p>
				)}
				{result.timeGapMs !== null && (
					<p className="result-row">
						<span className="result-row-label">Gap</span>
						{formatSeconds(result.timeGapMs)}
					</p>
				)}
			</div>
			<div className="menu-footer-actions">
				{onNextLevel && (
					<button className="btn-pixel btn-pixel--primary" onClick={onNextLevel}>
						Next Level
					</button>
				)}
				<button className={onNextLevel ? "btn-pixel btn-pixel--secondary" : "btn-pixel btn-pixel--primary"} onClick={onPlayAgain}>
					Play Again
				</button>
				<button className="btn-pixel" onClick={onViewLeaderboard}>
					View Leaderboard
				</button>
			</div>
		</div>
	);
}
